import events from './events.json'

/**
 * Please ctrl/cmd + click on biEvents to see the schema :)
 * @type {Object.<String, BIEvent>}
 */
export default events
